import { request, requestOptional } from "./http";
import type { UserRole }             from "../auth/roles";
import type { UserRoleEntry }         from "./types";

export type { UserRoleEntry };

/** Retourne le rôle d'un utilisateur par email, ou null s'il n'en a pas encore. */
export function getRole(email: string): Promise<UserRole | null> {
  return requestOptional<{ role: UserRole }>(
    `/roles/${encodeURIComponent(email)}`
  ).then(data => data?.role ?? null);
}

/** Retourne la liste de tous les rôles enregistrés (hors super-admin). */
export const listRoles = () =>
  request<UserRoleEntry[]>("/roles");

/** Crée ou met à jour le rôle d'un utilisateur. */
export function setRole(email: string, name: string, role: UserRole): Promise<void> {
  return request<{ ok: boolean }>(`/roles/${encodeURIComponent(email)}`, {
    method: "PUT",
    body:   JSON.stringify({ name, role }),
  }).then(() => undefined);
}

/** Supprime le rôle d'un utilisateur (revient au rôle par défaut). */
export function removeRole(email: string): Promise<void> {
  return request<{ ok: boolean }>(`/roles/${encodeURIComponent(email)}`, {
    method: "DELETE",
  }).then(() => undefined);
}
